<template>
    <div class='container'>
        <el-image :src="require(`@/static/image/login/background.png`)" style="width:100%;height: 100%;" fit="fill"
            class="backgroundImage"></el-image>
        <div class="infoContent ">
            <div class="flex-center">
                <el-radio-group v-model="radio1" @input="changeType()">
                    <el-radio-button :label="item.label" v-for="(item, index) in typeList" :key="index"
                        :name="item.id"></el-radio-button>
                    <!-- <el-radio-button label="个人注册"></el-radio-button> -->
                </el-radio-group>
            </div>
            <div style="height: 60vh;margin-top:1px;overflow-y: auto;">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-position="top">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="tel">
                        <el-input v-model="ruleForm.tel" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code" class="codeBox">
                        <el-input placeholder="请输入验证码" v-model="ruleForm.code" class="publicclass" style="width: 100%;">
                            <template slot="append"><span class="cursor" @click="getCaptcha">{{ buttonText }}</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="email">
                        <el-input v-model="ruleForm.email"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="company" v-if="radio1 == '企业注册'">
                        <el-input v-model="ruleForm.company"></el-input>
                    </el-form-item>
                    <el-form-item label="城市" prop="city_id" v-if="radio1 == '企业注册'">
                        <!-- <el-select v-model="ruleForm.city_id" placeholder="请选择城市" style="width: 100%;">
                            <el-option label="上海" value="0"></el-option>
                            <el-option label="北京" value="1"></el-option>
                        </el-select> -->
                        <div class="cursor" @click="dialogVisible = true">
                            <el-input placeholder="请选择城市" v-model="select" class="input-with-select">
                                <!-- <template slot="prepend">
                                <div class="cursor" @click="dialogVisible = true">{{ select || '全国' }}<i
                                        class="el-icon-caret-bottom"></i></div>
                            </template> -->
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="radio1 == '企业注册' ? '经营年限' : '同行业年限'" prop="company_year">
                        <el-input v-model="ruleForm.company_year"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="预算" prop="name">
                        <div class="flex-between">
                            <el-input v-model="ruleForm.name" placeholder="投资预算" style="flex: 0 0 46%;"></el-input>
                            <el-input v-model="ruleForm.name" placeholder="月度营收预期" style="flex: 0 0 46%;"></el-input>
                        </div>
                    </el-form-item> -->
                    <el-form-item>
                        <div class="flex-between" style="align-items: end;">
                            <el-form-item prop="company_fee" style="flex: 0 0 46%;" label="预算" v-if="radio1 == '企业注册'">
                                <el-input v-model="ruleForm.company_fee" placeholder="投资预算"></el-input>
                            </el-form-item>
                            <el-form-item prop="company_month_fee"
                                :style="radio1 == '企业注册' ? 'flex: 0 0 46%;' : 'flex: 0 0 100%;'"
                                :label="radio1 == '企业注册' ? '' : '预算'">
                                <el-input v-model="ruleForm.company_month_fee" placeholder="月度营收预期"></el-input>
                            </el-form-item>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div>
                <div style="margin-top: 30px;width: 100%;" class="flex-center">
                    <el-button type="primary" class="publicclass" @click="submitForm('ruleForm')">注册</el-button>
                </div>
                <div style="margin-top:10px;width: 100%;color: #999999;cursor: pointer;" class="flex-center text">
                    <div class="radiobox flex-center" @click="changeRadio"
                        :style="{ color: radio ? '#0092FF' : '', borderColor: radio ? '#0092FF' : '' }"><i
                            class="el-icon-check" v-if="radio"></i></div>
                    <span @click="changeRadio">阅读并同意</span><span class="price"
                        @click="getInfo('user_agreement')">《用户协议》</span><span class="price"
                        @click="getInfo('privacy')">《隐私政策》</span>
                </div>
            </div>
        </div>
        <el-dialog title="城市" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <cityPage @changeCity="changeCity" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import cityPage from '@/components/cityPage.vue';
export default {
    name: '',
    components: {
        cityPage,
    },
    data() {
        return {
            radio1: '企业注册',
            ruleForm: {
                // name: '',
                // region: '',
                // date1: '',
                // date2: '',
                // type: [],
                // resource: '',
                // desc: '',
                // // city: ""

                tel: '',
                code: "",
                // user_type: "1",
                key: "",
                name: "",
                email: "",
                company: "",
                city_id: "",
                company_year: "",
                company_fee: "",
                company_month_fee: "",
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '长度在11字符', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                city_id: [
                    { required: true, message: '请选择城市', trigger: 'change' }
                ],
                company_year: [
                    { required: true, message: '请输入年限', trigger: 'blur' },
                ],
                company_fee: [
                    { required: true, message: '请输入投资预算', trigger: 'blur' },
                ],
                company_month_fee: [
                    { required: true, message: '请输入月收入预期', trigger: 'blur' },
                ],
                // date1: [
                //     { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                // ],
                // date2: [
                //     { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
                // ],
                // type: [
                //     { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
                // ],
                // resource: [
                //     { required: true, message: '请选择活动资源', trigger: 'change' }
                // ],
                // desc: [
                //     { required: true, message: '请填写活动形式', trigger: 'blur' }
                // ]
            },
            typeList: [
                {
                    label: "企业注册",
                    id: '1',
                },
                {
                    label: "个人注册",
                    id: '2',
                }
            ],
            radio: false,
            isDisabled: false, // 控制按钮是否禁用
            countdown: 0, // 倒计时时间
            intervalId: null, // 定时器的ID
            dialogVisible: false,
            select: "",
        }
    },
    beforeMount() {
        console.log(this.$route.path, 'this.$route.path');
    },
    mounted() {
    },
    beforeDestroy() {
    },
    computed: {
        user_type() {
            return this.radio1 == '企业注册' ? "1" : '2'
        },
        buttonText() {
            return this.isDisabled ? `${this.countdown}秒后重新获取` : '获取验证码';
        },
    },
    methods: {
        changeRadio() {
            this.radio = !this.radio
            console.log(this.radio, 'changeRadio')
        },
        getInfo(type) {
            // this.$router.push({
            //     path: '/article', query: {
            //         type: type 
            //     },target:'_blank'
            // });
            // this.$router.go(0)
            const targetRoute = this.$router.resolve({ name: 'article', query: { type: type } });
            window.open(targetRoute.href, '_blank');
        },
        submitForm(formName) {
            if (!this.radio) {
                this.$message.warn('请先同意《用户协议》《隐私政策》')
                return
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.user_type = this.user_type
                    console.log(this.ruleForm, 'ruleForm');
                    this.$api.index.register(this.ruleForm).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            this.$router.push('/login')
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changeType() {
            console.log('changeType', this.radio1);
            this.resetForm('ruleForm')
        },
        async getCaptcha() {
            if (this.isDisabled) return; // 如果按钮被禁用，则不执行任何操作
            if (!this.ruleForm.tel) {
                this.$message.error('请先输入手机号')
                return
            }
            // 发送获取验证码的请求（这里应该是你的API调用） 
            await this.$api.index.getVerify({ type: '2' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.ruleForm.key = res.data.key
                    this.$api.index.sendSms({ key: this.ruleForm.key, tel: this.ruleForm.tel }).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$message.success('验证码已发送')

                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.$message.error('请求失败请稍后重试')
                }
            })
            console.log('发送验证码请求');

            // 开始倒计时
            this.startCountdown();
        },
        startCountdown() {
            this.isDisabled = true; // 禁用按钮
            this.countdown = 60; // 设置倒计时为60秒
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown -= 1; // 每秒减少1
                } else {
                    clearInterval(this.intervalId); // 倒计时结束，清除定时器
                    this.isDisabled = false; // 重新启用按钮
                    this.countdown = 0; // 重置倒计时时间
                }
            }, 1000); // 每秒执行一次
        },

        submit() {
            this.select = localStorage.getItem('cityName')
            this.ruleForm.city_id = localStorage.getItem('cityId')
            this.dialogVisible = false
        },
        changeCity(item) {
            localStorage.setItem('cityId', item.id)
            localStorage.setItem('cityName', item.title)
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
    },
}
</script>

<style scoped lang="scss">
.container {
    height: 100vh;
    position: relative;
    overflow-y: hidden;
    min-width: 1200px;
}

.backgroundImage {
    position: absolute;
    left: 0;
    top: 0;
}

.infoContent {
    // width: 530px;
    // height: 840px;
    height: 90vh;
    background: #FFFFFF;
    box-shadow: 0px 3px 35px 0px rgba(42, 163, 254, 0.15);
    position: absolute;
    right: 5%;
    top: 5vh;
    padding: 30px 50px;
    box-sizing: border-box;
}

.publicclass {
    width: 100%;
}

::v-deep .el-form-item {
    margin-bottom: 10px;
}

::v-deep .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 30px;
}

::v-deep .codeBox .el-input__inner {
    border-right: transparent;
}

::v-deep .el-input-group__append {
    background: transparent;
    border-left: transparent;
    color: #0092FF;
}

::v-deep .el-input__inner:focus {
    border-color: #DCDFE6;
}

.radiobox {
    width: 14px;
    height: 14px;
    padding: 8px;
    border: 1px solid #999999;
    border-radius: 100%;
    margin-right: 6px;
    margin-top: 2px;
}
</style>